// extracted by mini-css-extract-plugin
export default {"container":"YHxs","divider":"fNMp","wrapper":"WKVR","btnWrapper":"MrDH"};